import React, { useState, useRef, useEffect } from 'react'
import swal from 'sweetalert';
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions'
import done from '../../../../assets/images/done.png';
import DropIn from 'braintree-web-drop-in-react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Button } from '@mui/material';
import { ThreeDots } from 'react-loader-spinner'
import Loader from "./loader";




const SERVER_URL = process.env.REACT_APP_API_URL;
function Payment({ mobile, handlePage, confirmation, choosedVoucherCount, choosedplan_id, orderSummaryData}) {


  const [loading, setLoading] = useState(false);
  const instanceRef = useRef(null);
  const [clientToken, setClientToken] = useState("")
  const [defaultCard, setdefaultCard] = useState("")
  const [existingCard, setExistingCard] = useState(0)
  const [disabled, setDisabled] = useState(false)
  const [checkBox, setCheckBox] = useState(false)
  const [checkBoxError, setCheckBoxError] = useState(false)
  const [paymentGateway, setPaymentGateWay] = useState(null)


  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };






  useEffect(() => {
    fetchDefaultCard()
  }, [])






  const fetchDefaultCard = async () => {
    try {
      const headers = await getApiHeader();
      setLoading(true)
      const response = await axios.get(`${SERVER_URL}retailer-default-card`,
        {
          headers: headers,
        }
      );
      if (response?.status === 200) {
        const paymentMethods = response?.data?.data?.payment_methods;
        console.log("payment Methods", paymentMethods)
        if (typeof paymentMethods === "object" && !Array.isArray(paymentMethods) && paymentMethods !== null) {
          setdefaultCard(paymentMethods);
          setExistingCard(1);
          setLoading(false);
        } else {
          fetchToken();
        }
      } else {
        fetchToken();
      }

    } catch (error) {
      console.log("entry into catch  case")
      fetchToken();

    }
  };



  const fetchToken = async () => {
    try {
      setLoading(true);
      const headers = await getApiHeader();
  
      
      const response = await axios.get(
        `${SERVER_URL}recharge-voucher-queueing/payments/get-voucher-client-token`,
        { headers } 
      );
  
      if (response.status === 200) {
        const token = response.data?.data?.clientToken; 
        if (token) {
          setClientToken(token);
          setPaymentGateWay(true);
         setTimeout(()=>{
          setLoading(false)
         },5000)


        } else {
          console.warn("Client token is empty.");
        }
      }
    } catch (error) {
      console.error("Error fetching client token:", error.message);
    } finally {
      // setLoading(false);
    }
  };
  



  const handleCheckBox = () => {
    setCheckBox((prevCheckBox) => {
      const newCheckBoxState = !prevCheckBox;

      if (newCheckBoxState) {
        // If checked, clear error and enable button
        setCheckBoxError(false);
        setDisabled(false);
      } else {
        // If unchecked, set error and disable button
        setCheckBoxError(true);
        setDisabled(true);
      }

      return newCheckBoxState;
    });
  }

  const handlePaymentSubmit = async (event) => {
    try {
      event.preventDefault()
      if (!checkBox) {
        setCheckBoxError(true);
        setDisabled(true);
        return;
      }

      setLoading(true)
      setDisabled(true)
      let nonce = null;

      if (existingCard === 0) {
        const paymentMethod = await instanceRef.current.requestPaymentMethod();
        nonce = paymentMethod.nonce;
      }

      const headers = await getApiHeader();
      const payload = {
        payment_method_nonce:nonce,
        mobile_number: mobile,
        plan_id: choosedplan_id,
        voucher_count: choosedVoucherCount,
        page: 'payment'
      };

      const response = await axios.post(
        `${SERVER_URL}recharge-voucher-queueing/update-plan-vouchers-queueing`,
        payload,
        { headers }
      );

      console.log(response);
      console.log(response.status);
      console.log(response.data.data);

      if (response.status === 200) {

          
          setLoading(false)
          // swal({
          //   title: "Success",
          //   text: response.data.message,
          //   icon: "success",
          //   button: "Close"
          // });

        setLoading(false);
        swal("Success", "Vouchers queueing completed successfully!","success");
        if(response?.data?.data?.orderSummary){
          orderSummaryData(response.data.data.orderSummary);
          handlePage('summary');

        }

        console.log('completed');
        
        

      } else { }
    } catch (error) {
      if (error.name === "DropinError") {
        setDisabled(false)
        swal("Error in Payment", error.message, "warning");
      }else if(error?.response?.data?.message){
        swal({
          title: "error",
          text: error?.response?.data?.message,
          icon: "error",
          button: "Close"
        })
      }

      setLoading(false)
      // const message = error?.response?.data?.message
      
    } finally {
      setLoading(false);
    }
  };





  


  return (

    <>
      <div className="formbold-main-wrapper add-plan-wrapper">
        <div className="formbold-form-wrapper add-plan-form pos-rel">

          <h6>Payment</h6>
          <hr />


          {loading === true && (
              <Loader />
          )}
          <br/>


          <div className="col-lg-4"></div>

          <div className="col-lg-4" style={{margin: '0 auto'}}>

              <div className="payment-gateway-wrapper">  
                  {defaultCard && existingCard === 1 ? (
                    <div className="recharge-defaultCard col-lg-12">
                      <div className="recharge-defaultCardBox">
                        <p>Paying With Card</p>
                        <ul className="recharge-defaultCardDetails">
                          <li>
                            <img src={defaultCard.imageUrl} alt="Card Image" />
                          </li>
                          <li>
                            <span>Ending In {defaultCard.last4}</span>
                            <span>{defaultCard.cardType}</span>
                          </li>
                          <li>
                            <img src={done} alt="Done Icon" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                      paymentGateway && (
                        <div >
                          <DropIn
                            options={{
                              authorization: clientToken,
                            }}
                            onInstance={(instance) => (instanceRef.current = instance)}
                          />
                        </div>
                      )
                )}

                <label className="check-box add-mb-accept-pay">
                  <input
                    type="checkbox"
                    required=""
                    id="agreeTerms"
                    title="Please check and agree to the terms and conditions"
                    onChange={handleCheckBox}
                  />
                  I have read and accept the{' '}
                  <a
                    target="_blank"
                    href="https://www.telsim.com.au/website-terms-conditions/"
                    rel="noopener noreferrer"
                  >
                    Terms & Conditions
                  </a>
                  , the Acceptable Use Policy, and the{' '}
                  <a
                    target="_blank"
                    href="https://www.telsim.com.au/website-privacy-policy/"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>{' '}
                  for my Telsim service.
                  <span className="tick"></span>
                </label>

                {checkBoxError && !checkBox && (
                  <p className="error-label">
                    Please check and agree to the terms and conditions
                  </p>
                )}

                <div textAlign="center" mt={4}>
                  <Button
                    variant="outlined"
                    disabled={disabled}
                    sx={{
                      backgroundColor: '#C11D6C',
                      color: '#fff',
                      // width: { xs: '100%', sm: '440px' },
                      width:'100%',
                      '&:hover': {
                        backgroundColor: '#9C1554',
                      },
                    }}
                    onClick={handlePaymentSubmit}
                  >
                    Submit
                  </Button>
                </div>

              </div>


          </div>


          <div className="col-lg-4"></div>

          <br/>
          <br/>


        </div>
      </div>
    </>
    )
}

export default Payment